module.exports = __webpack_public_path__ + "img/thea_pack.105b056f.png";